import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, PropertyValueMap, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { VersionStepDto } from '@/api-sdk';

import { isScrolledIntoView, scrollStepIntoView } from '@/utils';

import '../fg-configurator-step';
import './color-version/fg-version-options-list';

@customElement('fg-configurator-step-version')
@localized()
export class FgConfiguratorStepVersion extends LitElement {
  @property({ type: Array })
  versions: VersionStepDto['versions'] = [];

  @property({ type: String })
  validationMessage?: string | null;

  @property({ type: Boolean })
  scrollToStep = false;

  @property({ type: Boolean })
  showValidationMessage = false;

  render() {
    return html`
      <fg-configurator-step
        .stepTitle=${t('headers.chooseProduct')}
        .validationMessage=${this.validationMessage}
        .showValidationMessage=${this.showValidationMessage}
      >
        <fg-version-options-list
          .options=${this.versions}
        ></fg-version-options-list>
      </fg-configurator-step>
    `;
  }

  protected willUpdate(
    _changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>,
  ): void {
    if (_changedProperties.has('scrollToStep') && this.scrollToStep) {
      scrollStepIntoView(this);
      isScrolledIntoView(this);
    }
  }
}
